import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../environments/environment';

declare function gtag(...args: unknown[]): void;

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly platformId = inject(PLATFORM_ID);

  trackEvent(eventName: string, params: Record<string, string | boolean> = {}): void {
    if (!isPlatformBrowser(this.platformId) || typeof gtag === 'undefined') return;
    gtag('event', eventName, { ...params, send_to: environment.gaMeasurementId });
  }
}
